import icon from './logos/ooopener.svg'

export default icon ;